import axios from 'axios'
import Global from '../Global'
import { sessionHeader } from './main.api';
import ChannelApi from './channel.api';
import SessionManager from '../../Manager/Session.manager';
import { Channel } from '../../classes/Channel';
import VueSignals from '../VueSignals';
import UserApi from './user.api';

export default class PostApi {
    constructor(){}

    static create(message, channel_id, files = [], type = "normal"){
        let result = null
        let data = {
            "origin": message,
            "type": type,
            "channel_id": channel_id,
            "files":files,
        }
        if(channel_id == VueSignals.DRAFT_CHANNEL_ID){
            ChannelApi.createDirect(SessionManager.getLoggedInUserId()).then(res => {
                if(res.data.result){
                    SessionManager.UpdateChannel(res.data.channel.channel_id, new Channel(res.data.channel))
                }
                data = {
                    "origin": message,
                    "type": type,
                    "channel_id": res.data.channel.channel_id,
                    "files":files
                }
                result = PostApi.tryToFeedMessage(data)
            }).catch(function(err) {
                Global.globalValue(VueSignals.SOCKET_MESSAGE_POSTED, {
                    "event": VueSignals.SOCKET_MESSAGE_POSTED,
                    "data": data
                })
                console.log(err)
                //if(typeof err.response != "undefined" && err.response.status == 401){
                //     Global.logout()
                //     sessionStorage.setItem("invalid_session_id", true)
                // }
            })
        }else {
            result = PostApi.tryToFeedMessage(data)
        }

        return result
    }


    // to check if session id is invalid then update it
    static tryToFeedMessage(data){
        return axios.post(Global.GetAPIURL() + '/posts/create', JSON.stringify(data), sessionHeader).then(res => {
            if(res.data.result){
                return res
            }else {
                if(res.data.reason=="session_id_invalid"){
                    UserApi.UpdateSession()
                    PostApi.tryToFeedMessage(data)
                }
            }
        }).catch(function(err){
            console.log(err)
        })
    }

    static deletePost(post_id){
        let data = {
            "post_id": post_id
        }
        return axios
        .post(Global.GetAPIURL() + '/posts/delete', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
    static editPost(message_id, new_message, files = []){
        let data = {
            "origin": new_message,
            "post_id": message_id,
            "files":files
        }

        return axios
        .post(Global.GetAPIURL() + '/posts/edit', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static getPosts(channel_id, number, skip){
        if(Global.isLoggedIn()){
            let data = {
            "channel_id": channel_id,
            "number": number, //(optional) return maximum 10 posts
            "skip": skip, //(optional) return maximum 10 posts
            "sort_invert": true, //(optional) return sort option
            //"older_than": Math.floor(new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).getTime() / 1000),
            }
            return axios
            .post(Global.GetAPIURL() + '/posts/get', JSON.stringify(data), sessionHeader).catch(function(err) {
               if(typeof err.response != "undefined" && err.response.status == 401){
                    Global.logout()
                    sessionStorage.setItem("invalid_session_id", true)
                }
            })
        }
    }

    static getPostsWithSqn(channel_id, start_at, direction){
        let data = {
            "channel_id": channel_id,
            "start_sqn": start_at,
            "direction": direction, // direction of posts
            "number": 20
        }
        if(start_at == null){
            data = {
                "channel_id": channel_id,
                "direction": direction, // direction of posts
                "number": 20
            }
        }
        return axios
        .post(Global.GetAPIURL() + '/posts/get', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }


    static markAllRead(channel_id){
        let data = {
          "channel_id": channel_id,
          "mark_all": true
        }
        return axios
        .post(Global.GetAPIURL() + '/posts/mark_viewed', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static markRead(channel_id, post_ids){
        let data = {
          "channel_id": channel_id,
          "post_ids": post_ids
        }
        return axios
        .post(Global.GetAPIURL() + '/posts/mark_viewed', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static Search(channel_id, keyword, number = 20, skip = 0){
        let data = {
          "channel_id": channel_id,
          "keyword": keyword,
        //   "start_sqn": start_sqn, //(optional) return maximum 10 posts
          "direction": "up",
          "number": number, //(optional) number of entries
          "skip": skip, //(optional) return maximum 10 posts
        //   "sort_invert": true, //(optional) return sort option
        }
        return axios
        .post(Global.GetAPIURL() + '/posts/search', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

}
